






import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Form from '@/views/branding/components/Form.ts.vue';
import { BrandingData } from '@/views/branding/Branding';

const VisitManagement = namespace('visitManagement');

@Component({
  components: {
    Form
  }
})
export default class BrandingEdit extends Vue {
  private data: BrandingData = {};
  
  @VisitManagement.Action('getBrandItem')
  private getBrandItem!: (id: string) => Promise<BrandingData>;
  
  async created (): Promise<void> {
    this.data = await this.getBrandItem(this.$route.params.id);
  }
}
